var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_1119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17579 12.5216H7.92965V19.7419C7.92965 19.8845 8.04516 20 8.18771 20H11.1614C11.304 20 11.4195 19.8845 11.4195 19.7419V12.5556H13.4357C13.5668 12.5556 13.6771 12.4572 13.6921 12.327L13.9983 9.66885C14.0067 9.59572 13.9835 9.52248 13.9346 9.46761C13.8856 9.4127 13.8155 9.38126 13.742 9.38126H11.4196V7.71499C11.4196 7.2127 11.6901 6.95799 12.2235 6.95799C12.2996 6.95799 13.742 6.95799 13.742 6.95799C13.8845 6.95799 14 6.84243 14 6.69992V4.25997C14 4.11742 13.8845 4.00191 13.742 4.00191H11.6493C11.6346 4.00119 11.6018 4 11.5535 4C11.1904 4 9.9283 4.07128 8.93135 4.98844C7.82673 6.0048 7.98028 7.22173 8.01698 7.43272V9.38121H6.17579C6.03323 9.38121 5.91772 9.49672 5.91772 9.63928V12.2635C5.91772 12.406 6.03323 12.5216 6.17579 12.5216Z",
    fill: "white",
    stroke: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 3.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_1119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.2b6389355b2f249077bbd15b85e9e453.svg";
export { ForwardRef as ReactComponent };